import script from "./PushList.vue?vue&type=script&setup=true&lang=js"
export * from "./PushList.vue?vue&type=script&setup=true&lang=js"

import "./PushList.vue?vue&type=style&index=0&id=2905b42c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2905b42c"]])

export default __exports__